<template>
  <div>
    <div class="categoriesDiv">
      <div class="col-md-12">
        <div class="full_heading text_align_center heading_main heading_style_7 hide_heading_borden_style">
          <h2 class="pageTitle">{{ $t("categoriesTitle") }}</h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="search-bar">
        <input v-if="langVar === 'ar'" type="text" style="
            border: 1px solid lightgray;
            border-radius: 5px;
            padding: 1%;
            width: 100%;
            margin-bottom: 45px;
            margin-top: 25px;
          " placeholder="ما اسم القسم الذي تبحث عنه؟" v-model="searchKey" @input="searchCategories" />
      </div>
      <div class="search-bar">
        <input v-if="langVar === 'en'" type="text" style="
            border: 1px solid lightgray;
            border-radius: 5px;
            padding: 1%;
            width: 100%;
            margin-bottom: 45px;
            margin-top: 25px;
            direction: ltr;
          " placeholder="What Category are you searching for?" v-model="searchKey" @input="searchCategories" />
      </div>
      <div :class="{
        'row fullClassContainer': langVar === 'ar',
        'row fullClassContainerEn': langVar === 'en',
      }">
        <div class="col-md-12" v-if="categories.length == 0" style="text-align: center">
          {{ $t("noCategories") }}
        </div>
        <div v-else class="col-xs-12 col-sm-6 col-md-6 col-lg-4" v-for="(category, index) in categories" :key="index">
          <div class="full fullClass" style="cursor: pointer" @click="redirectToProducts(category.id)">
            <div class="footer_blog">


              <vue-load-image class="text-center">
                <template v-slot:image>
                  <img :src="category.imagee" :alt="category.name" class="card-img mb-5" style="border-radius: 15px; max-width: 300px; max-height: 300px;" />
                </template>
                <template v-slot:preloader>
                  <div class="spinner-border text-primary" role="status" style="text-align: center">
                    <span class="sr-only">Loading...</span>
                  </div>
                </template>
                <template v-slot:error>image load fails</template>
              </vue-load-image>
              <div class="footer_cont">
                <h5>{{ category.title }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="arabic-pagination mt-5" style="margin-right: 40%; padding-top:40px; width: auto" v-if="langVar === 'ar'">
        <paginate :page-count="totalPages" :click-handler="changePage" :prev-text="'السابق'" :next-text="'القادم'"
          :container-class="'pagination'" :page-class="'page-item'" :page-link-class="'page-link'"
          :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'"
          :next-link-class="'page-link'"></paginate>
      </div>
      <div class="arabic-pagination" style="margin-right: 35%; width: auto;" v-if="langVar === 'en'">
        <paginate :page-count="totalPages" :click-handler="changePage" :prev-text="'Prev'" :next-text="'Next'"
          :container-class="'pagination'" :page-class="'page-item'" :page-link-class="'page-link'"
          :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'"
          :next-link-class="'page-link'"></paginate>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "../../Axios";
import { mapState } from "vuex";
import Paginate from "vuejs-paginate";
import store from "../../store";
import VueLoadimage from "vue-load-image";

export default {
  components: {
    paginate: Paginate,
    "vue-load-image": VueLoadimage,
  },
  data() {
    return {
      categories: [],
      langVar: store.state.currentLang,
      currentPage: 1,
      totalPages: 1,
      searchKey: "",
    };
  },
  computed: {
    ...mapState(["currentLang"]),
    currentLang() {
      return store.state.currentLang;
    },
  },
  mounted() {
    Axios.get("/category", {
      params: {
        page: this.currentPage,
        limit: 6,
      },
    })
      .then((response) => {
        this.categories = response.data.categories.map((category) => {
          console.log(category);
          if (category.imagee && category.imagee.type === 'Buffer' && Array.isArray(category.imagee.data)) {
            const buffer = Buffer.from(category.imagee.data);
            const base64Image = buffer.toString('base64');
            category.imagee = `data:image/jpeg;base64,${base64Image}`; // Adjust MIME type if needed
          }
          return {
            id: category.id,
            title: category.name,
            imagee: category.imagee,
          };
        });
        this.totalPages = response.data.totalPages;
      })
      .catch((error) => {
        // console.error(error);
      });
  },
  methods: {
    searchCategories() {
      Axios.get(`/category/`, {
        params: { searchkey: this.searchKey, limit: 6 },
      })
        .then((response) => {
          // console.log(response.data);
          this.categories = response.data.categories.map((category) => {
            // console.log(category);
            if (category.imagee && category.imagee.type === 'Buffer' && Array.isArray(category.imagee.data)) {
            const buffer = Buffer.from(category.imagee.data);
            const base64Image = buffer.toString('base64');
            category.imagee = `data:image/jpeg;base64,${base64Image}`; // Adjust MIME type if needed
          }
            return {
              id: category.id,
              title: category.name,
              imagee: category.imagee,
            };
          });
          this.totalPages = response.data.totalPages;
        })
        .catch((error) => {
          this.categories = [];
          // console.error(error);
        });
    },

    changePage(pageNumber) {
      this.currentPage = pageNumber;
      Axios.get("/category", {
        params: {
          page: this.currentPage,
          limit: 6,
        },
      })
        .then((response) => {
          this.categories = response.data.categories.map((category) => {
            // console.log(category);

            if (category.imagee && category.imagee.type === 'Buffer' && Array.isArray(category.imagee.data)) {
            const buffer = Buffer.from(category.imagee.data);
            const base64Image = buffer.toString('base64');
            category.imagee = `data:image/jpeg;base64,${base64Image}`; // Adjust MIME type if needed
          }
            return {
              id: category.id,
              title: category.name,
              image: category.imagee,
            };
          });
          this.totalPages = response.data.totalPages;
        })
        .catch((error) => {
          // console.error(error);
        });
    },
    redirectToProducts(categoryID) {
      // Redirect to "/products" with the categoryID as a query parameter
      this.$router.push({ path: "/products", query: { categoryID } });

      // Fetch products based on the selected category ID
      this.fetchProductsByCategory(categoryID);
    },
    fetchProductsByCategory(categoryID) {
      Axios.get(`/product/category?categoryID=${categoryID}`)
        .then((response) => {
          this.$emit("productsFetched", response.data); // Emit an event to send the fetched products to the parent component
        })
        .catch((error) => {
          // console.error("Error fetching products:", error);
        });
    },
  },
};
</script>

<style>
@import "~@fortawesome/fontawesome-free/css/all.min.css";

/*
body {
  background-color: #f3f1f0;
}
*/
.pageTitle {
  padding-top: 120px;
  font-weight: 800;
  font-size: 40px;
  color: #b5aaa3;
  text-shadow: 0 2px 2px #444;
}

.categoriesDiv {
  text-align: center;
  background-image: url(../../assets/images/background.png);
  background-size: cover;
}

.fullClassContainerEn {
  margin-top: 40px;
  direction: ltr;
}

.fullClass {
  background-color: #e2d8ce49;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  box-shadow: 0 10px 30px -30px #5e5a57;
  height: 430px;
}

.fullClass:hover {
  animation: myAnim 4s infinite;
}

@keyframes myAnim {
  0% {
    transform: translate(0);
  }

  20% {
    transform: translate(-2px, 2px);
  }

  40% {
    transform: translate(-2px, -2px);
  }

  60% {
    transform: translate(2px, 2px);
  }

  80% {
    transform: translate(2px, -2px);
  }

  100% {
    transform: translate(0);
  }
}

.fullClass:hover {
  box-shadow: 0 20px 30px -30px #5e5a57;
}

.fullClass h4 {
  margin-right: 30px;
}

.footer_cont>h5 {
  text-align: center;
  line-height: 43px;
}

.footer_cont>h5:hover {
  color: #f7c74d;
}
</style>
